module.exports = __webpack_public_path__ + "static/media/Step 10f-Influencer.7220daba.png";